import { fetchGet } from 'Services/fetchService.js';
import { nodePath } from 'Config/path.js';

export default async (taskId) => {
    const result = await fetchGet(`${nodePath}/files/get-all-files-by-task?taskId=${taskId}`);

    return result || [];
};
